import React from "react";
import LocalStorage from "../tools/LocalStorage";
import branchInfo from "../models/branchInfo";
import token from "../models/token";
import branchDefaultValue from "../models/branchDefaultValue";
const AuthContext = React.createContext({
    authenticated: !!LocalStorage.getUser(),
    user:LocalStorage.getUser(),
    data:new branchDefaultValue(),
    handleData:(value:any)=>{},
    login: () => {},
    handleUser: (value:any) => {},
    logout:()=>{},
    handleBranches:(value:any)=>{},
    branches:[],
    currentFileNumber:null,
    Token:new token(),
    handleAccessToken:(value:any)=>{},
    handleCurrentFileNumber: (value:string|null)=>{},
    handleCurrentBranchInfo: (value:branchInfo)=>{},
    loading:true,
    handleAddBranchModal:(value:boolean)=>{},
    addBranchModalOpen:false,
    handleBranchInfo: (value:string)=>{},
    currentBranchInfo:new branchInfo()
});
export default AuthContext;